export default interface IEncodeFinishModel {
    set(): void;
}
